export default __webpack_public_path__ + "static/media/pexels-jéshoots-238118.ce1aca57.jpg";